import i18n from '../../../i18n';

const getDefaultState = () => ({
  items: [
    {
      subheading: i18n.t('menu.subheadings.general'),
      pages: [
        {
          title: i18n.t('menu.dashboard.link'),
          to: { name: 'Index' },
          icon: 'dashboard',
          exact: true,
        },
        {
          title: i18n.t('menu.xmlChannelStatus.link'),
          to: { name: 'XmlChannelStatus' },
          icon: 'ballot',
          exact: false,
        },
        {
          title: i18n.t('menu.prices.link'),
          to: { name: 'Prices' },
          icon: 'shopping_cart',
          exact: false,
        },
      ],
    },
    {
      subheading: i18n.t('menu.subheadings.links'),
      pages: [
        {
          title: i18n.t('menu.twenty.link'),
          href: process.env.TWENTY_FRONT_PAGE,
          icon: 'launch',
          exact: false,
        },
      ],
    },
  ],
  breadcrumbs: {
    breadcrumbs: [],
    title: '',
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/nav/defaultState.js